// extracted by mini-css-extract-plugin
export var aiStarIcon = "_7x-4";
export var closeButton = "_7x-6";
export var dismissButton = "_7x-3";
export var editImageWithAiContainer = "_7x-8";
export var imageUploadWrapper = "_7x-7";
export var misspelledWord = "_7x-5";
export var spellCheckContainer = "_7x-2";
export var spin = "_7x-1";
export var spinning = "_7x-0";